var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-wizard"},[_c('step-line',{attrs:{"steps":_vm.steps,"active":_vm.active,"clickable":_vm.canGoBack},on:{"select":_vm.goTo}}),_c('div',{staticClass:"step-content"},[_vm._t(_vm.currentStep.name,null,{"step":_vm.currentStep})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }